import { Component, HostListener, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomLoaderService } from '../services/custom-loader.service';
import { MainHeaderMenuService } from '../services/main-header-menu.service';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { LoginService } from '../services/login.service';
import { ClientDataService } from '../services/client-data.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from '../validation';
import { ProfileService } from 'src/app/services/profile.service';
import { CleverTapUtilityService } from '../services/clever-tap-utility.service';
declare var $: any;
@Component({
selector: 'app-cp-login-incred',
templateUrl: './cp-login-incred.component.html',
styleUrls: ['./cp-login-incred.component.scss']
})
export class CpLoginIncredComponent implements OnInit, AfterViewInit {
IsInvestor: boolean = false;
LoginForm: FormGroup;
LoginSubmitted: boolean = false;
UserType: number = 2;
IsShowLoginOption: boolean = true;
WelcomeText: any = '';
CompanyName: string = '';
logo: string;
NavHeight: string;
IsMobile: boolean = false;
logoWidth: string;
logoHeight: string;
CurrentCompanyName: string = environment.CompayName;
redirect_fd: any;
redirect_mf: any;
redirect_nfo: any;
redirect_preferscheme: any;
redirectTo: string = "";
TakeMeToPage: string = "/dashboard";
USERLoginId: any;
Token: string;
TokenArray: string[] = [];
UserId: string;
Password: string;
UserTypeSSO: string;
PageURL: string;
PageView: boolean=false; // display cp login page or not
IsFromDeepLink: boolean = false;
constructor(private LoginService: LoginService,
private EncrdecrService: EncrdecrService,
public ShowHideHeaderMenu: MainHeaderMenuService,
private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private Loader: CustomLoaderService,
private ClientDataService: ClientDataService,private clientProfileService: ProfileService,private Clevertap:CleverTapUtilityService) {
this.LoginForm = this.formBuilder.group({
Username: ['', Validators.required],
Password: ['', [Validators.required]],
UserType: ['2']
});
}
SetViewPort(w) {
if (w <= 767) {
this.IsMobile = true;
}
else {
this.IsMobile = false;
}
}
@HostListener('window:resize', ['$event'])
onResize(event) {
this.SetViewPort(event.target.innerWidth)
}
ngOnInit() {
debugger
//Added by Dalsukh (SSO Verification Module)
this.route.queryParams.subscribe(params => {
// console.log("Params",params);
this.Loader.show();
let parameters = params.dplk;
if(!isNullOrUndefined(parameters) && parameters != "" && parameters != "0"){
let Param = parameters.replace(/ /g, "+");
console.log(" value ->", Param);
sessionStorage.setItem('OPHqexF834YT4HhjG8', Param); // DeepLinkId
this.IsFromDeepLink = true;
}
else{
this.IsFromDeepLink = false;
}
this.Token = params['Data'];
if (this.Token) {
this.PageView = true;
debugger
this.LoginForm.controls["Username"].setValue(this.EncrdecrService.getDecr(sessionStorage.getItem('1rMWoq/fR0KsYA9AxL63Cw=='))); // Userid
this.LoginForm.controls["Password"].setValue(this.EncrdecrService.getDecr(sessionStorage.getItem('HNrvPKl2xEC1ZGyPqCxAOQ=='))); //Password
this.PageURL = this.EncrdecrService.getDecr(sessionStorage.getItem('+TrzWUXUJ0Cd20+J77gj4A==')) //Page URL
this.onSubmit()
}
});
//Ended by Dalsukh (SSO Verification Module)
// this.EncryptedToken = this.Token ;
// //Calling for checking flag of activation
// let obj = {
// Token: this.Token,
// Flag:"ActivePageCheck"
// }
// this.Token = this.encryptDecrypt.getDecr(this.Token) ;
// this.TokenArray = this.Token.split("`");
// this.UserId = this.TokenArray[0];
// this.UserType = this.TokenArray[1];
// this.Password = this.TokenArray[2];
this.SetViewPort(window.innerWidth);
this.getCompanyDetails();
sessionStorage.setItem("nvjsd212djskd$#21ksdj", "SB")
this.WelcomeText = this.ClientDataService.GetWelcomeText();
this.logo = sessionStorage.getItem('logo');
this.CompanyName = this.ClientDataService.GetCompanyName();
if (this.CompanyName == 'Mahindra') {
this.logoWidth = '330px';
this.logoHeight = '120px';
this.NavHeight = '40px';
$('.MainOuter').css('min-height', window.innerHeight - 70);
}
else if (this.CompanyName == 'AU') {
this.logoWidth = '130px';
this.logoHeight = '60px';
this.NavHeight = '62px';
$('.MainOuter').css('min-height', window.innerHeight - 0);
$('.LoginOuter').css('min-height', '100vh');
}
else if (this.CompanyName == 'YesSecurities') {
this.logoWidth = '150px';
this.logoHeight = '60px';
this.NavHeight = '62px';
$('.MainOuter').css('min-height', window.innerHeight - 75);
}
const CorporateFag = sessionStorage.getItem('Vbhs@#%LMKIo=');
if (CorporateFag == 'C') {
//this.ShowHideHeaderMenu.hide();
sessionStorage.removeItem('F44sGAGh2xwkpUL');//Session_SubBrokerId
sessionStorage.removeItem('Hldq31TLYwRbLJ8');//Session_SubBrokerCode
sessionStorage.removeItem('UZT6qHaDZSz66kx'); //Session_ClientBasicInfoId
sessionStorage.removeItem('N1QJHdOkO7Hz8QC'); //Session_ClientBasicInfoId
sessionStorage.removeItem('L2D3506kIHSk3E0'); //Session_UserType
sessionStorage.removeItem('pOWgAF62qFXnZMn'); // Session_Razor
sessionStorage.removeItem('W113TKilrF1u1gL'); // ucc code - client
sessionStorage.removeItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
sessionStorage.removeItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294');
sessionStorage.removeItem('hn0bHyGhfpGtrPe'); //family id
sessionStorage.removeItem('E#$%#XCha7%*=');
sessionStorage.removeItem('Vbhs@#%LMKIo=');
}
else {
this.router.parseUrl("**");
}
}
get r() {
return this.LoginForm.controls;
}













onSubmitMain(IPADD:string = '') {
debugger
this.LoginSubmitted = true;
//if (!this.LoginForm.invalid ) {//old conditin
//condition changed by dalsukh for sso login without password
if (this.LoginForm.invalid && !(!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A==")))) {
return;
}
else {
//////
this.Loader.show()
let DataBody = JSON.stringify(this.LoginForm.value);
sessionStorage.setItem('Tgsh@#3734fjfskshh==', IPADD);
let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
debugger
let LoginSource = "";
//setting flag based on sso login or normal based on session
if (!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A=="))) {
LoginSource = "SSO";
}
this.LoginService.PostLogin_NSE_Info(DataBody, this.UserType, IpAddress,LoginSource).then(
(res1: any) => {
debugger
let res = JSON.parse(this.EncrdecrService.getDecr(res1));
this.RedirectByLink();
if (res.Message != "Invalid Username and Password") {
sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID);
sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); //Session_SubBrokerId
sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); //Session_UserName
sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); //Session_UserEmail
sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); //Session_UserMobile
sessionStorage.setItem("kioh298hKh2kj", res.CorpIFDStatus);//CorpIFDFlag -- for corporate IFD
sessionStorage.setItem("23khokl2k35hl", res.PrimarySBCode);//PrimarySubBrokerCode -- for corporate IFD
sessionStorage.setItem("ZhdfjU423HG878", res.IsChildSB); //IsChildSB : Boolean Value -- Added by Saddam
sessionStorage.setItem("sd7BSDxhjk876f", res.IsMasterFranchise); //IsMasterFranchise Flag : (1 : MasterFranchise & 0 : Not) -- Added by Saddam
sessionStorage.setItem("fh9XFbhbd83r87", res.IsCorporateIFD); //IsCorporateIFD Flag : (1 : CorporateIFD & 0 : Not) -- Added by Saddam
sessionStorage.setItem('ksdhUEDH78$#OPL', res.UserIPAddress); // Logged In User IP Address : Added by Saddam
sessionStorage.setItem('Sdfg0978&#NlpmB', res.CorporateIFDSBCode); // Corporate IFD SB Code : Added by Saddam
// let login_id = this.EncrdecrService.getDecr(res.LOGIN_ID)
// let SubBrokerCode = this.EncrdecrService.getDecr(res.SubBrokerCode);
// let USER_ID = this.EncrdecrService.getDecr(res.USER_ID)
if (res.RazorCustId !== null && res.RazorCustId !== undefined && res.RazorCustId !== 'null') {
sessionStorage.setItem('pOWgAF62qFXnZMn', res.RazorCustId); //RazorCustId
}
else {
sessionStorage.setItem('pOWgAF62qFXnZMn', ''); //RazorCustId
}
sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); //Session_SubBrokerCode
sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); //Session_UserType
sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); //Session_CBId
sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); //Session_B64CompanyLogo
//sessionStorage.setItem('Session_B64CompanyLogo_EtE',res.Companylogobase64);
if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID); //Session_Family_ID
}
// Added by Tishya for IIFL-2030
let rr1 = '',rr2 = '',rr3 = '',rr4 = ''
let r1 = sessionStorage.getItem('m5JkoXISmYRAIuY'); //Session UserId
let r2 = sessionStorage.getItem('L2D3506kIHSk3E0'); //Session UserType
let r3 = sessionStorage.getItem('V8hpPfITcxhEI9x'); //Session EmailId
let r4 = sessionStorage.getItem('Xe003SRRyYEoOC2'); //Session UserMobile
if(r1){
rr1 = this.EncrdecrService.getDecr(r1);
}
if(r2){
rr2 = this.EncrdecrService.getDecr(r2);
}
if(r3){
rr3 = this.EncrdecrService.getDecr(r3);
}
if(r4){
rr4 = this.EncrdecrService.getDecr(r4);
if(rr4!="")
{
rr4 = rr4.includes('+91') ? rr4.replace(/\s+/g, '') : `+91${rr4.trim()}`
}
}
let UserInfo = {
"Site":{
"Identity":rr1,
"UserType":rr2,
"Email":rr3,
"Phone":rr4
}
}
console.log("CleverTap UserLoginEvent : ", UserInfo);
this.Clevertap.userLoginEvent(UserInfo);
switch (this.EncrdecrService.getDecr(res.USER_TYPE)) {
case "2":
sessionStorage.setItem('m5JkoXISmYRAIuY', res.SubBrokerCode); //Session_UserId
this.USERLoginId = res.SubBrokerCode
sessionStorage.setItem('currentstatus', res.CurrentStatus);
console.log("LogoImage", res.SBLoginBase64PP);
// if (res.SBLogoBase64 != null && res.SBLogoBase64 != "" && res.SBLogoBase64 != undefined) {
// sessionStorage.setItem('SBLoginBase64PP', res.SBLogoBase64);
// }
if(this.IsFromDeepLink){
window.location.href = '/deeplink-redirector';
}
else if (!isNullOrUndefined(sessionStorage.getItem("sdfetrtr"))) {
let fdData = sessionStorage.getItem("sdfetrtr");
window.location.href = '/fd/fd-landing';
sessionStorage.removeItem('sdfetrtr');
}
else if (!isNullOrUndefined(sessionStorage.getItem("fgrtrytyt"))) {
let mfData = sessionStorage.getItem("fgrtrytyt");
window.location.href = 'transaction-new/lumpsum';
sessionStorage.removeItem('fgrtrytyt');
}
else if (!isNullOrUndefined(localStorage.getItem("isnfoyes"))) {
let nfoData = localStorage.getItem("isnfoyes");
setTimeout(() => {
window.location.href = 'explore-funds-new';
}, 1000)
// localStorage.removeItem('isnfoyes');
}
else if (!isNullOrUndefined(localStorage.getItem("ispreferyes"))) {
let preferschemeData = localStorage.getItem("ispreferyes");
setTimeout(() => {
window.location.href = 'explore-funds-new';
}, 1000)
// localStorage.removeItem('isprefe ryes');
}
else if (this.redirectTo != "") {
setTimeout(() => {
window.location.href = this.redirectTo;
}, 1000)
}
//Added by Dalsukh SSO verification Module
else if (!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A=="))) {
this.Loader.hide();
sessionStorage.removeItem('1rMWoq/fR0KsYA9AxL63Cw==');
sessionStorage.removeItem('HNrvPKl2xEC1ZGyPqCxAOQ==');
sessionStorage.removeItem('+TrzWUXUJ0Cd20+J77gj4A==');
//this.router.navigateByUrl("/" + this.PageURL);
window.location.href = "/" + this.PageURL;
}
//Ended by Dalsukh SSO verification Module
else {
this.Loader.hide();
sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', res.RazorePaymentStatus)
//this.router.navigate(['/payment'], { relativeTo: this.route });
//this.router.navigate(['/dashboard'], { relativeTo: this.route });
window.location.href = this.TakeMeToPage || '/dashboard';
}
break;
}
}
else {
this.Loader.hide();
this.CallAlertModal('Please enter valid username and password');
}
},
(err: any) => {
////////
//console.log(err)
let rr = err.error;
let er = rr.substring(1, rr.length - 1);
let rk = er.split(", ");
this.Loader.hide();
if (rk[1].includes('Number of invalid login attempts')) {
this.CallAlertModal('Number of invalid login attempts. Your account is locked for 15 minutes')
}
else {
this.CallAlertModal('Please enter valid username and password');
}
////console.log('err =>' + er);
}
);
}
}
onSubmit(){
this.clientProfileService.getIPAddress().subscribe((res:any)=>{
debugger
let ipAddress=res.ip;
this.onSubmitMain(ipAddress);
},
error => {
this.onSubmitMain("");
})
}
SendUserType() {
//////
sessionStorage.setItem('L2D3506kIHSk3E0', this.EncrdecrService.setEncr(this.UserType.toString()));
}
CallAlertModal(msg: any) {
$("#AlertModal").modal({
backdrop: 'static',
keyboard: false
});
$('#AlertModalContent').text(msg);
}
getCompanyDetails() {
this.ClientDataService.getCompanyDetails(environment.CompanyId).subscribe((data: any) => {
this.Loader.hide();
if (data != null && data.ArrayOfResponse.length != 0) {
let rk = data.ArrayOfResponse[0];
console.log('Corp_IFA = ' + this.EncrdecrService.getDecr(rk.Dummy1));
//this.Companyname = rk.CompanyName;
if (this.ClientDataService.GetCompanyName() == 'AU') {
sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("4"));
sessionStorage.setItem('Mnuoisns6wqgswj2$#', "1");
}
else if (this.ClientDataService.GetCompanyName() == 'Mahindra') {
sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("2"));
sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
}
else if (this.ClientDataService.GetCompanyName() == 'YesSecurities') {
sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("11"));
sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
}
else {
sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("0"));
sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
}
sessionStorage.setItem('E#$%#XCha7%*=', this.EncrdecrService.getDecr(rk.Dummy2));
sessionStorage.setItem('Vbhs@#%LMKIo=', this.EncrdecrService.getDecr(rk.Dummy1));
sessionStorage.setItem('DufjGDH3843JE', this.EncrdecrService.getDecr(rk.Dummy4));
sessionStorage.setItem('PfdkSJDNWks2323Ms', this.EncrdecrService.getDecr(rk.Dummy3));
sessionStorage.setItem('Arh34SDBJSSiF', this.EncrdecrService.getDecr(rk.Dummy5));
sessionStorage.setItem('Fhd63asja$%Wsdjs9304#@dfvdjfjd', this.EncrdecrService.getDecr(rk.Dummy6));
sessionStorage.setItem('cIe+MhBUozWO3+mKZd2to=', this.EncrdecrService.getDecr(rk.EnableRiskProfile));
}
});
}

ngAfterViewInit() {
$(".TakeMeTo_DDl").select2({
minimumResultsForSearch: -1,
dropdownCssClass: 'TakeMeTo_Dropdown',
containerCssClass: 'TakeMeTo_Container'
});
$(".TakeMeTo_DDl").on('change', (e: any) => {
this.TakeMeToPage = $(e.target).val();
});
}

RedirectByLink() {
try {
var fd_url = ('https://alpha.incredmarkets.com//login-cp?redirect_fd=fd/fd-landing');
var mf_url = ('https://alpha.incredmarkets.com//login-cp?redirect_mf=transaction-new/lumpsum');
var nfo_url = ('https://alpha.incredmarkets.com//login-cp?redirect_nfo=explore-funds-new&IsNFO=true');
var preferscheme_url = ('https://alpha.incredmarkets.com//login-cp?redirect_preferscheme=explore-funds-new&IsPreferred=true');
this.route.queryParams.subscribe((queryParam) => {
if (queryParam.redirect_fd != undefined) {
this.redirect_fd = queryParam.redirect_fd;
sessionStorage.setItem("sdfetrtr", this.redirect_fd);
}
});
this.route.queryParams.subscribe((queryParam) => {
if (queryParam.redirect_mf != undefined) {
this.redirect_mf = queryParam.redirect_mf;
sessionStorage.setItem("fgrtrytyt", this.redirect_mf);
}
});
this.route.queryParams.subscribe((queryParam) => {
//
if (queryParam.redirect_nfo != undefined) {
this.redirect_nfo = queryParam.redirect_nfo;
localStorage.setItem("isnfoyes", this.redirect_nfo);
}
});
this.route.queryParams.subscribe((queryParam) => {
if (queryParam.redirect_preferscheme != undefined) {
this.redirect_preferscheme = queryParam.redirect_preferscheme;
localStorage.setItem("ispreferyes", this.redirect_preferscheme);
}
});
this.route.queryParams.subscribe((queryParam) => {
if (queryParam.redirectTo != undefined) {
this.redirectTo = queryParam.redirectTo;
}
if (queryParam.flag != undefined) {
if (queryParam.flag == "NFO") {
sessionStorage.setItem("Xb5weBH3kMGpXLalI=", "nfo");
} else if (queryParam.flag == "PrefScheme") {
sessionStorage.setItem("Xb5weBH3kMGpXLalI=", "ff");
}
}
});
} catch (error) {
console.log(error)
}
}
}